import {
    SET_USER_FEATURE_MAP,
} from '../../state/mutation-types';
import {
    formatString,
  } from "@config/utils";

export const actionSetUserFeatureMap = async (context, commit, data) => {
    if(data) {
        await searchAddress(context, data)
        .then( data => {
            commit(SET_USER_FEATURE_MAP, data && data.street ? data : null);
        });
    }else{
        commit(SET_USER_FEATURE_MAP, null);
    }
};

export const searchAddress = async (context, data) => {
    if(data) {
        let url = data.url;
        if(!url) {
            console.error('missing URL to get address');
            return null;
        }
        let coords = data.coords || data.map_coords;
        url = formatString(url, {lon: coords.lon, lat: coords.lat, srid: data.srid || 4326});
        return await context.$http.get(url)
        .then( res => {
            let _data = res.data.data !== undefined ? res.data.data : res.data;
            if(_data != null){
                _data.street = _data.full_name || _data.name || _data.rua;
                Object.assign(data, _data);
                // delete data.coord;
                // delete data.coordinates;
                delete data.url;
                return data;
            }
            return null;
        })
        .catch( error => {
            console.error(error);
            return null;
        })

    }
    return null;
};